module.exports = __webpack_public_path__ + "static/media/10_The broken mirror_TI.3aaa2197.txt";